import { create } from 'zustand';
import { devtools, persist } from 'zustand/middleware';

interface ConfigurationState {
  friendly_url: string;
  module: string;
  main_module: string;
  init: (params: {
    friendly_url: string;
    module: string;
    main_module: string;
  }) => void;
  reset: () => void;
}

export const useConfigurationStore = create<ConfigurationState>()(
  devtools(
    persist(
      (set) => ({
        friendly_url: '',
        module: '',
        main_module: '',
        init: ({ friendly_url, module, main_module }) =>
          set({ friendly_url, module, main_module }),
        reset: () => set({ friendly_url: '', module: '', main_module: '' })
      }),
      { name: 'configuration-storage' }
    ),
    { name: 'ConfigurationStore' }
  )
);
